import { ButtonProps } from '@material-ui/core/Button';
import { PopoverOrigin } from '@material-ui/core/Popover';
import { Theme } from '@material-ui/core/styles';
import AddTimeOffRequestIcon from '@material-ui/icons/AddAlarm';
import AddIcon from '@material-ui/icons/AddCircleOutline';
import { ClipboardTextOutline as PostScheduleIcon } from 'mdi-material-ui';
import React from 'react';
import { UTC } from 'rewire-common';
import { Observe } from 'rewire-core';
import {
  ActionMenu,
  IActionMenuItem,
  WithStyle,
  // IFormContext,
  // Form,
} from 'rewire-ui';
import { ITimecard } from '../DataTypes';
import mainPageModel from '../main-navigation/MainPageModel';
import { RouteManagerBase } from '../main-navigation/RouteManager';
import Routes from '../Routes';
import PostedScheduleDialog from '../schedule/PostedScheduleDialog';
import postedScheduleDialogModel from '../schedule/PostedScheduleDialogModel';
import scheduleModel from '../schedule/ScheduleModel';
import { dialogInfoPanelTimeOffRequestViewModel } from '../timeoff/InfoPanelTimeOffRequestViewModel';
import TimeOffDialog from '../timeoff/TimeOffDialog';
import timeOffDialogModel from '../timeoff/TimeOffDialogModel';
import timeOffModel from '../timeoff/TimeOffModel';
import { withStyles } from '../utility/styles';

const styles = (theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'stretch',
  },
  addMenuButton: {
    margin: '0px 10px',
    padding: '7px',
    minHeight: '0px',
    '&:hover, &:active': {
      background: 'transparent',
    },
  },
  listItemText: {
    fontSize: 'inherit',
  },
  addIcon: {
    color: theme.palette.navBarSecondary.main,
    '&:hover': {
      color: theme.palette.navBarPrimary.main,
    },
  },
});

interface IMainContentNavbarAddMenuProps {}
type MainContentNavbarAddMenuProps = WithStyle<ReturnType<typeof styles>, IMainContentNavbarAddMenuProps>;

const isWorkedByEmployee = (shift: ITimecard) => shift.reason?.category === 'worked' && !!shift.employee;

class MainContentNavbarAddMenu extends React.Component<MainContentNavbarAddMenuProps> {
  constructor(props: MainContentNavbarAddMenuProps) {
    super(props);
  }

  shouldComponentUpdate(_nextProps: MainContentNavbarAddMenuProps) {
    return false;
  }

  handleAddTimeOffRequestClick = () => {
    timeOffModel.addTimeOffRequest();
    if (RouteManagerBase.current?.route !== Routes.TimeOffList && RouteManagerBase.current?.route !== Routes.TimeOffCalendar) {
      let start = UTC.MaxValue;
      let end = UTC.MinValue;
      let employee: any | undefined;
      let units = 0;
      for (const shift of scheduleModel.getSelectedShifts(isWorkedByEmployee)) {
        if (!employee) {
          employee = shift.employee;
        }

        if (shift.employee?.id !== employee?.id) {
          continue;
        }
        start = start.date < shift.earnedDate.date ? start : shift.earnedDate;
        end = end.date > shift.earnedDate.date ? end : shift.earnedDate;
        units += shift.units ?? 0;
      }

      dialogInfoPanelTimeOffRequestViewModel.loadEmployeeRange(employee, start, end, units);
      timeOffDialogModel.open();
    } else {
      timeOffModel.addTimeOffRequest();
    }
  };

  handlePostedScheduleClick = () => {
    postedScheduleDialogModel.load();
  };

  render() {
    const { classes } = this.props;
    const buttonContent = <AddIcon fontSize="large" className={classes.addIcon} />;
    const buttonProps: ButtonProps = { disableRipple: true, size: 'large' };
    const anchorOrigin: PopoverOrigin = { vertical: 'bottom', horizontal: 'right' };
    const transformOrigin: PopoverOrigin = { vertical: 'top', horizontal: 'right' };
    const items: IActionMenuItem[] = [
      {
        name: 'addTimeOffRequest',
        title: 'Add Time Off Request',
        closeOnClick: true,
        icon: AddTimeOffRequestIcon,
        divider: true,
        onClick: this.handleAddTimeOffRequestClick,
        visible: () => mainPageModel.timeOffRequestAccess,
        disabled: () => !mainPageModel.canAddTimeOffRequests,
      },
      {
        name: 'postedSchedule',
        title: 'Post Schedule',
        icon: PostScheduleIcon,
        divider: true,
        onClick: this.handlePostedScheduleClick,
        visible: () => mainPageModel.scheduleAccess,
        disabled: () => !mainPageModel.canEditSchedule,
      },
    ];

    return (
      <Observe
        render={() => (
          <div className={classes.root}>
            <ActionMenu
              menuId="main-content-navbar-add-menu"
              items={items}
              buttonContent={buttonContent}
              buttonProps={buttonProps}
              classes={{ menuButton: classes.addMenuButton, listItemText: classes.listItemText }}
              getContentAnchorEl={null}
              anchorOrigin={anchorOrigin}
              transformOrigin={transformOrigin}
            />
            <TimeOffDialog />
            <PostedScheduleDialog />
          </div>
        )}
      />
    );
  }
}

export default withStyles<IMainContentNavbarAddMenuProps>(styles, MainContentNavbarAddMenu);
